<template>
    <main-layout class="bg-gray-100 min-h-screen flex flex-col list-bouteilles">
        <!-- En-tête + CTA + recherche + filtres -->
        <div class="bg-gradient-to-b from-secondary to-primary">
            <div class="p-2 space-y-3 pb-6">
                <app-header icon="bouteille" class="text-white">
                    <div class="flex items-center justify-between">
                        <h1 class="text-xl font-semibold tracking-wide text-right">Restitution bouteille<br>en volume</h1>
                    </div>
                </app-header>

                <action-bar :back="{ name: 'home' }" class="!p-0 !m-0">
                    <a id="main-action" @click.prevent="restitution"
                        class="inline-flex items-center gap-2 bg-white text-primary text-sm font-medium px-4 py-2 rounded-lg shadow-sm hover:shadow transition">
                        <i class="inline-block h-6 w-6 mask mask-more bg-primary"></i>
                        <span><strong>Rendre</strong> ces bouteilles</span>
                    </a>
                </action-bar>

                <!-- Barre de recherche seule -->
                <filter-bar @searchBarChanged="updateSearch" :placeholderFilter="'Recherche par code, fluide, otag'"
                    type-history="bouteille" class="block pb-5" />
            </div>
        </div>


        <div class="bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 shadow-xl pb-28">

            <div v-if="this.bouteilles.length === 0" style="text-align: center">
                <span class="loading">Chargement des bouteilles<span class="point-1">.</span><span
                        class="point-2">.</span><span class="point-3">.</span></span>
            </div>
            <div>
                <div id="bouteilles-item" class=" p-2 list list-bout rounded-2xl overflow-hidden shadow-2xl restitution">
                    <div v-for="bout in filtredBottles()" :key="bout.id" class="check odd:bg-white even:bg-[#F7FAFD]"
                        :data-fournisseur="bout.fournisseur">
                        <input type="checkbox" :id="'restit-' + bout.id" class="peer sr-only"
                            @change="changeUpdate(bout)">
                        <label :for="'restit-' + bout.id"
                            class="flex items-start gap-3 cursor-pointer border border-transparent transition-all duration-200 bg-transparent peer-checked:bg-red-500/20 peer-checked:border-red-600 p-3">
                            <div class="flex-1">
                                <!-- Distributeur -->
                                <p class="text-md text-primary">
                                    Distributeur :
                                    <span class="font-bold">
                                        <template v-if="bout.fournisseur">{{ bout.fournisseur.nom }}</template>
                                    </span>
                                </p>

                                <h2 class="text-xl mt-1">
                                    Bouteille <span class="font-bold"><template v-if="bout.nom">{{
                                        bout.nom.nom }}</template></span>
                                </h2>

                                <!-- Ligne d'infos -->
                                <div class="flex items-center gap-3 mt-3">
                                    <!-- Fluide (pastille colorée par TYPE de bouteille) -->
                                    <div v-if="bout.fluide"
                                        class="flex items-center gap-1 px-3 py-1 rounded-r-full -ml-3 text-white text-sm font-medium"
                                        :class="bout.type === 'Fluide frigorigène'
                                            ? 'bg-gaz-ff'
                                            : (bout.type === 'Récupération' ? 'bg-gaz-rec' : 'bg-gaz-tf')">
                                        <i class="inline-block h-5 w-5 mask mask-snow bg-white"></i>
                                        {{ bout.fluide.nom }}
                                    </div>

                                    <!-- Code bouteille -->
                                    <div class="flex items-center gap-1">
                                        <i class="inline-block h-5 w-5 mask mask-bouteille" :class="bout.type === 'Fluide frigorigène'
                                            ? 'bg-gaz-ff'
                                            : (bout.type === 'Récupération' ? 'bg-gaz-rec' : 'bg-gaz-tf')"></i>
                                        <span class="text-md font-medium" :class="bout.type === 'Fluide frigorigène'
                                            ? 'text-gaz-ff'
                                            : (bout.type === 'Récupération' ? 'text-gaz-rec' : 'text-gaz-tf')">{{
                                                bout.code
                                            }}</span>
                                    </div>

                                    <!-- OTAG -->
                                    <div v-if="bout.otag" class="flex items-center gap-1">
                                        <i class="inline-block h-6 w-6 mask mask-otag" :class="bout.type === 'Fluide frigorigène'
                                            ? 'bg-gaz-ff'
                                            : (bout.type === 'Récupération' ? 'bg-gaz-rec' : 'bg-gaz-tf')"></i>
                                        <span class="text-md font-medium" :class="bout.type === 'Fluide frigorigène'
                                            ? 'text-gaz-ff'
                                            : (bout.type === 'Récupération' ? 'text-gaz-rec' : 'text-gaz-tf')">{{
                                            bout.otag
                                        }}</span>
                                    </div>
                                </div>
                                <!-- Barre de niveau (si OTAG) -->
                                <div v-if="bout.otag" class="mt-3">
                                    <div class="w-full bg-gray-200 rounded-full h-2">
                                        <div class="h-2 rounded-full" :class="bout.type === 'Fluide frigorigène'
                                            ? 'bg-gaz-ff'
                                            : (bout.type === 'Récupération' ? 'bg-gaz-rec' : 'bg-gaz-tf')"
                                            :style="getProgressStyle(bout)"></div>
                                    </div>
                                    <p class="text-sm text-gray-600 mt-1">
                                        {{ bout.poids_net ? bout.poids_net : 0 }} kg /
                                        {{ bout.poids_max ? bout.poids_max : 0 }} kg
                                    </p>
                                </div>
                            </div>
                            <!-- Checkbox visible à droite -->
                            <div class="flex-shrink-0 mt-1">
                                <div class="checkbox-visual w-6 h-6 border-2 rounded border-gray-400 flex items-center justify-center transition-all duration-200">
                                    <span class="check-icon hidden text-white font-bold text-lg leading-none">×</span>
                                </div>
                            </div>
                        </label>
                    </div>
                </div>

            </div>
        </div>
    </main-layout>
</template>

<script>
import Bouteille from '../../js/models/Bouteille'
import Scan from '../../js/models/Scan'
import { empty } from "leaflet/src/dom/DomUtil";

export default {

    data() {
        return {
            bouteilles: [],
            strSearch: ''
        }
    },

    methods: {
        getProgressStyle(bout) {
            const net = bout.poids_net ? bout.poids_net : 0;
            const max = bout.poids_max ? bout.poids_max : 0;
            const pct = max ? Math.min(100, Math.ceil((net * 100) / max)) : 0;

            return {
                width: pct + '%'
            }
        },

        getStyle(poids_net, poids_max) {
            return {
                width: Math.ceil(poids_net * 100 / poids_max) + '%'
            }
        },

        changeUpdate(bout) {
            let bouts = document.querySelectorAll('.check > input:checked');
            if (bouts.length > 0) {

            } else {
                let checks = document.getElementsByClassName('check')
            }
        },

        async fetchBouteilleClosed() {

            let listBouteilles = await Bouteille.getList();

            for (let bout in listBouteilles) {
                let res = await Bouteille.isRendable(listBouteilles[bout].id);

                if (listBouteilles[bout].type !== "Fluide frigorigène" && listBouteilles[bout].poids_net !== 0) {
                    res = false;
                }

                if (res === true) {
                    this.bouteilles.push(listBouteilles[bout])
                }
            }

        },

        updateSearch(str) {
            this.strSearch = String(str[0]).toLowerCase()
        },

        classBouteille(type) {
            switch (type) {
                case 'Fluide frigorigène':
                    return 'ff';
                case 'Récupération':
                    return 'rec';
                case 'Transfert':
                    return 'tf'
            }
        },

        async restitution() {
            let bouts = document.querySelectorAll('.check > input:checked');
            let ids = [];

            _.each(bouts, check => {

                if (!_.includes(check.value, 'N-')) {
                    ids.push(parseInt(check.value))
                } else {
                    ids.push(check.value)
                }

            });

            for (let id of ids) {
                await Scan.addOfflineScanBouteille(id)
            }

            if (ids.length > 0) {

                Bouteille
                    .restitution(ids, false, true)
                    .then(() => {
                        this.$router.push({ name: 'home' });
                        swal('Bouteille(s) restituée(s)', 'Restitution effectuée', 'success')
                    })
                    .catch()

            } else {
                swal('Aucune bouteille sélectionnée', 'Veuillez au moins sélectionner une bouteille', 'warning')
            }
        },
        filtredBottles(searchTemp = null) {
            let search = this.strSearch;
            if (searchTemp !== null) {
                search = searchTemp
            }

            return this.bouteilles.filter(b => {
                let check = false;
                if (_.has(b, 'fluide') && b.fluide && b.fluide.nom.toLowerCase().includes(search)) {
                    check = true
                }

                if (b.otag && b.otag.toLowerCase().includes(search)) {
                    check = true
                }

                if (b.fournisseur.nom.toLowerCase().includes(search)) {
                    check = true
                }

                if (b.code.toLowerCase().includes(search)) {
                    check = true
                }
                if (check) {
                    return b
                }
            })
        }
    },

    computed: {

    },

    mounted() {
        this.fetchBouteilleClosed()
    }

}

</script>

<style scoped>
/* Animation du loader */
.point-1,
.point-2,
.point-3 {
    display: inline-block;
}

.point-1 {
    animation: bounce 1s ease-in-out infinite;
}

.point-2 {
    animation: bounce 1s ease-in-out 0.33s infinite;
}

.point-3 {
    animation: bounce 1s ease-in-out 0.66s infinite;
}

/* Checkbox sélection restitution */
.list-bout.restitution input[type="checkbox"]:checked+label>div:not(.clear) {
    border: none;
}

/* Checkbox visuelle à droite */
.list-bout.restitution input[type="checkbox"]:checked+label .checkbox-visual {
    border-color: #dc2626;
    background-color: #dc2626;
}

.list-bout.restitution input[type="checkbox"]:checked+label .checkbox-visual .check-icon {
    display: block;
}
</style>



// WEBPACK FOOTER //
// RestitutionBouteilles.vue?1d079fb5